import { Captions } from 'components/Typography';
import styled from 'styled-components';

export const StyledCaptions = styled(Captions)`
  padding: 10px 70px;
  text-align: center;
`;
